import {combineReducers} from "redux";

import tagsListReducer from "./tagsList";


export default combineReducers({
    tagsList : tagsListReducer,
});